"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NeedsAttention;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function NeedsAttention(_ref) {
  var {
    className
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "108",
    height: "108",
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "54",
    cy: "54",
    r: "54",
    fill: "#F6BE00"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M75.6103 39.8204V57.8204C75.6103 79.8204 53.6103 86.9204 53.6103 86.9204C53.6103 86.9204 32.0004 79.9204 32.0004 57.7004V31.2904C31.9949 30.9882 32.0505 30.688 32.1636 30.4077C32.2768 30.1274 32.4453 29.8728 32.659 29.6591C32.8727 29.4453 33.1273 29.2769 33.4076 29.1637C33.6879 29.0505 33.9881 28.9949 34.2903 29.0004H73.3404C73.6426 28.9949 73.9428 29.0505 74.2231 29.1637C74.5034 29.2769 74.758 29.4453 74.9717 29.6591C75.1854 29.8728 75.3539 30.1274 75.4671 30.4077C75.5803 30.688 75.6358 30.9882 75.6304 31.2904M67.8404 50.9104H57.9203V41.3704H49.6904V50.9104H39.7704V58.8304H49.6904V68.3704H57.9203V58.8304H67.8404V50.9104Z",
    stroke: "#002E6B",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M75.6103 36.4297C76.4829 36.4297 77.3197 36.7763 77.9367 37.3933C78.5537 38.0103 78.9003 38.8472 78.9003 39.7197C78.9017 40.1526 78.8175 40.5815 78.6528 40.9818C78.488 41.3821 78.2459 41.7459 77.9403 42.0525C77.6346 42.3591 77.2715 42.6023 76.8717 42.7683C76.4719 42.9343 76.0432 43.0197 75.6103 43.0197C75.1774 43.0197 74.7488 42.9343 74.349 42.7683C73.9492 42.6023 73.586 42.3591 73.2804 42.0525C72.9748 41.7459 72.7326 41.3821 72.5679 40.9818C72.4031 40.5815 72.319 40.1526 72.3203 39.7197C72.3203 38.8472 72.667 38.0103 73.284 37.3933C73.9009 36.7763 74.7378 36.4297 75.6103 36.4297Z",
    fill: "#4DC7EB"
  }));
}